export async function searchStores({
  keyword,
  page,
  limit = 10,
}: {
  keyword: string | undefined | null;
  page: number;
  limit?: number;
}) {
  try {
    if (!keyword) return;
    let baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/store-similarity?page=${page}&limit=${limit}&query=${keyword}`;
    const repsonse = await fetch(baseUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const stores = await repsonse.json();
    return stores;
  } catch (error) {
    console.error(error);
  }
}
